import React, { useState } from 'react';
import './Cart.css';

const Cart = () => {
  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('khuleg.cart') || '[]');
    } catch { return []; }
  });
  const [msg, setMsg] = useState('');
  const [paying, setPaying] = useState(false);

  const handleRemove = (id) => {
    const next = cart.filter((x) => x._id !== id);
    setCart(next);
    localStorage.setItem('khuleg.cart', JSON.stringify(next));
  };

  const handlePay = () => {
    setPaying(true);
    setTimeout(() => {
      setMsg('Төлбөр амжилттай төлөгдлөө!');
      setCart([]);
      localStorage.setItem('khuleg.cart', '[]');
      setPaying(false);
      setTimeout(() => setMsg(''), 4000);
    }, 1800);
  };

  if (!cart.length) return <div>Сагс хоосон байна.</div>;

  const total = cart.reduce((sum, i) => sum + (i.price || 0), 0);

  return (
    <div className="cart-page">
      <h2>Миний сагс</h2>
      <ul>
        {cart.map(item => (
          <li key={item._id} style={{marginBottom:12}}>
            <span>{item.title}</span> —
            <span> {item.price?.toLocaleString()}₮</span>
            <button onClick={() => handleRemove(item._id)} title="Устгах" style={{marginLeft:12}}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 8V14M10 8V14M14 8V14M3 5H17M5 5V4C5 2.89543 5.89543 2 7 2H13C14.1046 2 15 2.89543 15 4V5M8 2H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span style={{marginLeft:4}}>Устгах</span>
            </button>
          </li>
        ))}
      </ul>
      <div className="cart-total" style={{marginTop:18,marginBottom:18,fontWeight:600,fontSize:18}}>
        Нийт: {total.toLocaleString()}₮
      </div>
      <button onClick={handlePay} disabled={paying} style={{marginTop:8,padding:'10px 28px',fontSize:17,borderRadius:18,background:'#0ea5e9',color:'#fff',fontWeight:600,border:'none',cursor:'pointer'}}>
        {paying ? 'Төлбөр төлж байна...' : 'Төлбөр төлөх'}
      </button>
      {msg && <div style={{marginTop:16, color:'#059669',fontWeight:500}}>{msg}</div>}
    </div>
  );
};

export default Cart;
